import React from 'react';
import styled from 'styled-components';
import {useParams} from 'react-router-dom';
import {
  useWorkflowQuery,
  useUpdateWorkflowSearchConditionMutation,
  useAllFormsQuery,
} from 'api';
import {Checkbox} from 'components/antd';
import useClientUser from 'hooks/useClientUser';

export default () => {
  const {isMember} = useClientUser();
  const {workflowId} = useParams<{
    poolId: string;
    workflowId: string;
  }>();

  const {data: {workflow = {}, workflow: {searchCondition = {}} = {}} = {}} =
    useWorkflowQuery({
      variables: {uuid: workflowId},
      fetchPolicy: 'cache-and-network',
    });

  const {data: {allForms = []} = {}} = useAllFormsQuery({
    fetchPolicy: 'cache-and-network',
  });

  const [updateWorkflowSearchCondition] =
    useUpdateWorkflowSearchConditionMutation({
      refetchQueries: ['workflowProspectPoolCountsByStatus'],
    });

  const isConditionUpdatable = React.useMemo(
    () => workflow?.status === 'draft',
    [workflow],
  );

  return (
    <Item>
      <Label>フォーム</Label>
      <CheckboxGroup
        value={searchCondition?.forms || []}
        disabled={!isConditionUpdatable || !isMember}
        onChange={(values: string[]) =>
          updateWorkflowSearchCondition({
            variables: {
              uuid: workflowId,
              attributes: {
                forms: values,
              },
            },
          })
        }>
        {allForms.map((form) => (
          <Checkbox value={form.id} key={form.id}>
            {form.title}
          </Checkbox>
        ))}
      </CheckboxGroup>
    </Item>
  );
};

const Item = styled.div`
  display: flex;
  margin-bottom: 30px;
`;

const Label = styled.div`
  width: 115px;
  font-weight: 500;
  font-size: 14px;
`;

const CheckboxGroup = styled(Checkbox.Group)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;

  & > * {
    padding: 0 !important;
    margin: 0 !important;
  }
  .ant-checkbox-wrapper {
    display: flex;
    align-items: center;
  }
  .ant-checkbox {
    top: 0;
  }
`;
